"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var querySelector_1 = require("./querySelector");
exports.find = function (element, selector) {
    var nodes = [];
    var matches = querySelector_1.querySelector(selector, element);
    var l = matches.length;
    for (var i = 0; i < l; ++i) {
        if (nodes.indexOf(matches[i]) === -1) {
            nodes.push(matches[i]);
        }
    }
    return nodes;
};
exports.findOne = function (element, selector) {
    var results = exports.find(element, selector);
    return results.length > 0 ? results[0] : undefined;
};
exports.findForceOne = function (element, selector) {
    var results = exports.find(element, selector);
    if (results.length === 0) {
        throw new ReferenceError("Could not find any matches for \"" + selector + "\" in Element.");
    }
    return results[0];
};
